import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import AccountStatusControl from '../components/AccountStatusControl';

export default function AdminAccountStatusPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>Account Status Management</Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Control and manage user account statuses. Changes will immediately affect user access and permissions.
        </Typography>
        
        <AccountStatusControl />
      </Box>
    </Container>
  );
}
